/** @format */
import clsx from "clsx";
import { useRef } from "react";
import { Dialog } from "primereact/dialog";

import { useState, useMemo, useCallback } from "react";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";

import { ReactComponent as DeleteIcon } from "../../assets/DeleteSurvey.svg";
import { SURVEY } from "./constants/constants";
import { capitalCase } from "text-capital-case";
import View from "./View";
import Delete from "./Delete";

const SurveyListItem = ({ title, status, index, surveyId: id, ...rest }) => {
  const [view, setView] = useState(-1);

  let navigate = useNavigate();
  let toastRef = useRef(null);

  const viewHandler = useCallback(() => {
    setView(1);
  }, [setView]);
  const editHandler = useCallback(() => {
    navigate(`/survey/edit/${id}`);
  }, [navigate, id]);
  const showDelete = useCallback(() => {
    setView(2);
  }, [setView]);

  const isView = useMemo(() => view === 1, [view]);
  const isDelete = useMemo(() => view === 2, [view]);
  const isActive = useMemo(() => status.toLocaleLowerCase() === SURVEY.STATUS.ACTIVE.toLocaleLowerCase(), [status]);
  const isInProgress = useMemo(
    () => status.toLocaleLowerCase() === SURVEY.STATUS.IN_PROGRESS.toLocaleLowerCase(),
    [status]
  );
  const isInactive = useMemo(() => status.toLocaleLowerCase() === SURVEY.STATUS.INACTIVE.toLocaleLowerCase(), [status]);
  const resetView = useCallback(() => setView(-1), [setView]);

  return (
    <div className={`grid align-items-center box ${index === 0 ? "mt-2" : "mt-3"}`}>
      <Toast ref={toastRef} baseZIndex={20000} />
      <div className='col-3'>{title}</div>
      <div
        className={clsx({
          "col-3": true,
          survey__active: isActive,
          survey__inprogress: isInProgress,
          survey__inactive: isInactive,
        })}
      >
        {capitalCase(status)}
      </div>
      <div className='col-3 col-offset-3 flex-row-reverse flex align-items-center'>
        {isInProgress ? (
          <>
            <span onClick={showDelete} className='floatRight mr-0' style={{ cursor: "pointer" }}>
              <DeleteIcon />
            </span>
            <span className='expand mr-0' onClick={editHandler}>
              Edit
            </span>
          </>
        ) : null}
        {!isInProgress ? (
          <span className='expand ml-0' onClick={viewHandler}>
            View Details
          </span>
        ) : null}
      </div>
      <Dialog
        baseZIndex={10001}
        header={<Delete.Header />}
        closable={false}
        visible={isDelete}
        style={{ width: "25vw" }}
        onHide={() => {}}
        focusOnShow={false}
        className='mi__dialog'
        id='dialog__survey__delete'
      >
        <Delete resetView={resetView} id={id} toastRef={toastRef} />
      </Dialog>
      <Dialog
        baseZIndex={10001}
        header={null}
        showHeader={false}
        closable={false}
        visible={isView}
        style={{ width: "65vw" }}
        onHide={() => {}}
        focusOnShow={false}
        className='mi__dialog'
        id='dialog__survey__details'
      >
        <View
          id={id}
          status={status}
          isActive={isActive}
          isInProgress={isInProgress}
          isInactive={isInactive}
          resetView={resetView}
          toastRef={toastRef}
        />
      </Dialog>
    </div>
  );
};

export default SurveyListItem;
